import React from "react";
import "../../Style/buttonMenu.css"; // Importa el CSS

interface MenuButtonProps {
  isActive: boolean;
  onClick: () => void | undefined;
  size?: number; // Tamaño en píxeles (opcional, por defecto 50px)
}

const MenuButton: React.FC<MenuButtonProps> = ({ isActive, onClick, size = 50 }) => {
  return (
    <button
      className={`menu-button ${!isActive ? "menu-is--visible" : ""}`}
      onClick={onClick}
      style={{ "--menu-size": `${size}px` } as React.CSSProperties} // Define la variable CSS
    >
      <div className={`menu-button__hb ${!isActive ? "menu-button__hb--is-active" : ""}`}>
        <span></span>
      </div>
    </button>
  );
};

export default MenuButton;
